import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nResources, getDefaultLanguage, supportedLanguages } from '@sheshdash/shared';

i18n
  .use(initReactI18next)
  .init({
    resources: i18nResources,
    lng: getDefaultLanguage(),
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
